"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var toggleSwitchStyles = makeStyles_1.default(function (theme) { return ({
    root: {
        width: '42px',
        height: '26px',
        padding: "0px 0 2px 0",
        margin: theme.spacing(1),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: theme.palette.primaryDisabled.main,
                opacity: 1,
                border: ".5px solid " + theme.palette.grey[400],
            },
        },
        '&$focusVisible $thumb': {
            color: theme.palette.primary.light,
            border: "6px solid " + theme.palette.common.white,
        },
    },
    switchContainer: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 0 15px',
        '& p:first-child': {
            marginRight: '20px',
        },
    },
    label: {
        fontFamily: theme.typography.fontFamily2,
        marginRight: '15px',
    },
    thumb: {
        width: '22px',
        height: '22px',
    },
    track: {
        borderRadius: '13px',
        border: ".5px solid " + theme.palette.grey[400],
        backgroundColor: theme.palette.primaryDisabled.main,
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
    selectCurrency: {
        color: theme.palette.text.primary,
        fontFamily: theme.typography.fontFamily2,
    },
    unselectedCurrency: {
        color: theme.palette.text.primary,
    },
    selectedCurrency: {
        fontFamily: theme.typography.fontFamily2,
        color: theme.palette.primary.main,
    },
}); }, { name: 'Summary_CurrencySwitch' });
exports.default = toggleSwitchStyles;
